var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { TitledContext } from './TitledContext';
import { useTitledValues } from './useTitledValues';
/**
 * TitledProvider is a context provider component to make useAuth() available to our app.
 */
export function TitledProvider(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const titledValues = useTitledValues(props);
    return (React.createElement(TitledContext.Provider, { value: titledValues }, children));
}
